<script setup lang="ts">
withDefaults(defineProps<{ tone?: 'error' | 'success' | 'info' }>(), { tone: 'info' })
</script>

<template>
  <div class="ck-alert" :class="`ck-alert--${tone}`" :role="tone === 'error' ? 'alert' : 'status'">
    <slot />
  </div>
</template>

<style scoped>
.ck-alert { padding: 12px 16px; border-radius: var(--radius-md); font-size: var(--fs-sm); line-height: var(--lh-normal); border: 1px solid transparent; margin-bottom: var(--space-4); }
.ck-alert--error { background: var(--ck-fail-bg); color: var(--ck-fail-text); border-color: var(--ck-fail-500); }
.ck-alert--success { background: var(--ck-ok-bg); color: var(--ck-ok-text); border-color: var(--ck-ok-500); }
.ck-alert--info { background: var(--ck-info-bg); color: var(--ck-info-text); border-color: var(--ck-info-500); }
.ck-alert :deep(a) { color: inherit; font-weight: var(--fw-bold); text-decoration: underline; }
</style>
